import AccessibilityIcon from './ic-accessibility.svg'
import AccountCardDetailsOutlineIcon from './ic-account-card-details-outline.svg'
import AccountCircleIcon from './ic-account-circle.svg'
import AccountIllustration from './il-account.svg'
import AccountVariantIcon from './ic-account-variant.svg'
import AddBoldIcon from './ic-add-bold.svg'
import AddIcon from './ic-add.svg'
import AddTextIcon from './ic-add-text.svg'
import AegisIcon from './ic-aegis.svg'
import ArchiveIcon from './ic-archive.svg'
import ArrowDownCheckmarkIcon from './arrow-down-checkmark.svg'
import ArrowDownIcon from './ic-arrow-down.svg'
import ArrowLeftIcon from './ic-arrow-left.svg'
import ArrowRightIcon from './ic-arrow-right.svg'
import ArrowsHorizontalIcon from './ic-arrows-horizontal.svg'
import ArrowsSortDownIcon from './ic-arrows-sort-down.svg'
import ArrowsSortUpIcon from './ic-arrows-sort-up.svg'
import ArrowsVerticalIcon from './ic-arrows-vertical.svg'
import ArrowUpIcon from './ic-arrow-up.svg'
import AsteriskIcon from './ic-asterisk.svg'
import AttachmentFileIcon from './ic-attachment-file.svg'
import AuthenticatorIcon from './ic-authenticator.svg'
import AuthenticatorVariantIcon from './ic-authenticator-variant.svg'
import BackIosIcon from './ic-back-ios.svg'
import BackspaceIcon from './ic-backspace.svg'
import BlockIcon from './ic-block.svg'
import BlueDotIcon from './blue-dot.svg'
import BoldIcon from './ic-bold.svg'
import BoxFilledIcon from './ic-box-filled.svg'
import BoxIcon from './ic-box.svg'
import CameraIcon from './ic-camera.svg'
import CaretRightIcon from './ic-caret-right.svg'
import CheckAllIcon from './ic-check-all.svg'
import CheckBoldIcon from './ic-check-bold.svg'
import CheckCircleFilledIcon from './ic-check-circle-filled.svg'
import CheckCircleIcon from './ic-check-circle.svg'
import CheckIcon from './ic-check.svg'
import CheckListIcon from './ic-list-check.svg'
import ChevronDownIcon from './ic-chevron-down.svg'
import ChevronLeftIcon from './ic-chevron-left.svg'
import ChevronRightIcon from './ic-chevron-right.svg'
import ChevronUpIcon from './ic-chevron-up.svg'
import CircleIcon from './circle-55.svg'
import ClearCircleFilledIcon from './ic-clear-circle-filled.svg'
import CloseCircleFilledIcon from './ic-close-circle-filled.svg'
import ClockIcon from './ic-clock.svg'
import CloseIcon from './ic-close.svg'
import CloudOffIcon from './ic-cloud-off.svg'
import CodeIcon from './ic-code.svg'
import CodeTagsIcon from './ic-code-tags.svg'
import ColorFillIcon from './ic-color-fill.svg'
import CopyIcon from './ic-copy.svg'
import CreateAccountIllustration from './create-account-illustration.svg'
import DashboardIcon from './ic-dashboard.svg'
import DiamondFilledIcon from './ic-diamond-filled.svg'
import DiamondIcon from './diamond-with-horizontal-lines.svg'
import DownloadIcon from './ic-download.svg'
import DragIcon from './ic-drag.svg'
import DrawIcon from './ic-draw.svg'
import EditorFilledIcon from './ic-editor-filled.svg'
import EditorIcon from './ic-editor.svg'
import EmailFilledIcon from './ic-email-filled.svg'
import EmailIcon from './ic-email.svg'
import EnterIcon from './ic-enter.svg'
import EvernoteIcon from './ic-evernote.svg'
import EyeFilledIcon from './ic-eye-filled.svg'
import EyeIcon from './ic-eye.svg'
import EyeOffFilledIcon from './ic-eye-off-filled.svg'
import EyeOffIcon from './ic-eye-off.svg'
import FeedbackIcon from './ic-feedback.svg'
import FileDocIcon from './ic-file-doc.svg'
import FileErrorIcon from './ic-file-error.svg'
import FileFilledIcon from './ic-file-filled.svg'
import FileIcon from './ic-file.svg'
import FileImageIcon from './ic-file-image.svg'
import FileMovIcon from './ic-file-mov.svg'
import FileMusicIcon from './ic-file-music.svg'
import FileOtherIcon from './ic-file-other.svg'
import FilePdfIcon from './ic-file-pdf.svg'
import FilePptIcon from './ic-file-ppt.svg'
import FileSelectedIcon from './ic-file-selected.svg'
import FilesIllustration from './il-files.svg'
import FileXlsIcon from './ic-file-xls.svg'
import FileZipIcon from './ic-file-zip.svg'
import FolderFilledIcon from './ic-folder-filled.svg'
import FolderIcon from './ic-folder.svg'
import FolderKeyFilledIcon from './ic-folder-key-filled.svg'
import FormatAlignCenterIcon from './ic-format-align-center.svg'
import FormatAlignJustifyIcon from './ic-format-align-justify.svg'
import FormatAlignLeftIcon from './ic-format-align-left.svg'
import FormatAlignRightIcon from './ic-format-align-right.svg'
import ForwardIosIcon from './ic-forward-ios.svg'
import FullscreenExitIcon from './ic-fullscreen-exit.svg'
import FullscreenIcon from './ic-fullscreen.svg'
import GiftOutlineIcon from './ic-gift-outline.svg'
import GoogleKeepIcon from './ic-gkeep.svg'
import GroupIcon from './ic-group.svg'
import HashtagFilledIcon from './ic-hashtag-filled.svg'
import HashtagIcon from './ic-hashtag.svg'
import HashtagOffIcon from './ic-hashtag-off.svg'
import HeartFilledIcon from './ic-heart-filled.svg'
import HelpFilledIcon from './ic-help-filled.svg'
import HelpIcon from './ic-help.svg'
import HistoryIcon from './ic-history.svg'
import HistoryLockedIllustration from './il-history-locked.svg'
import IconsSpriteStylekit from './icons-sprite-stylekit.svg'
import IlNotesIcon from './il-notes.svg'
import ImageIcon from './ic-image.svg'
import IndentIcon from './ic-indent.svg'
import InfoIcon from './ic-info.svg'
import ItalicIcon from './ic-italic.svg'
import KeyboardCloseIcon from './ic-keyboard-close.svg'
import KeyboardCommandIcon from './ic-keyboard-command.svg'
import KeyboardFilledIcon from './ic-keyboard-filled.svg'
import KeyboardIcon from './ic-keyboard.svg'
import KeyboardOptionIcon from './ic-keyboard-option.svg'
import KeyboardShiftIcon from './ic-keyboard-shift.svg'
import KeyboardShowIcon from './ic-keyboard-show.svg'
import LifebuoyIcon from './ic-lifebuoy.svg'
import LineWidthIcon from './ic-line-width.svg'
import LinkIcon from './ic-link.svg'
import LinkOffIcon from './ic-link-off.svg'
import ListBulleted from './ic-list-bulleted.svg'
import ListedFilledIcon from './ic-listed-filled.svg'
import ListedIcon from './ic-listed.svg'
import ListNumbered from './ic-list-numbered.svg'
import LockFilledIcon from './ic-lock-filled.svg'
import LockIcon from './ic-lock.svg'
import MarkdownIcon from './ic-markdown.svg'
import MenuArrowDownAlt from './ic-menu-arrow-down-alt.svg'
import MenuArrowDownIcon from './ic-menu-arrow-down.svg'
import MenuArrowRightIcon from './ic-menu-arrow-right.svg'
import MenuCloseIcon from './ic-menu-close.svg'
import MenuOpenIcon from './ic-menu-open.svg'
import MenuVariantIcon from './ic-menu-variant.svg'
import MergeIcon from './ic-merge.svg'
import MoreIcon from './ic-more.svg'
import MoreVertIcon from './ic-more-vert.svg'
import NoPreviewIllustration from './il-no-preview.svg'
import NotesFilledIcon from './ic-notes-filled.svg'
import NotesIcon from './ic-notes.svg'
import OpenInIcon from './ic-open-in.svg'
import OutdentIcon from './ic-outdent.svg'
import PasswordIcon from './ic-textbox-password.svg'
import PencilFilledIcon from './ic-pencil-filled.svg'
import PencilIcon from './ic-pencil.svg'
import PencilOffIcon from './ic-pencil-off.svg'
import PinFilledIcon from './ic-pin-filled.svg'
import PinIcon from './ic-pin.svg'
import PlainTextIcon from './ic-text-paragraph.svg'
import PlusCircleFilledIcon from './ic-plus-circle-filled.svg'
import PlusCircleIcon from './ic-plus-circle.svg'
import PremiumFeatureIcon from './ic-premium-feature.svg'
import PremiumIllustration from './il-premium.svg'
import PrintIcon from './ic-print.svg'
import ProtectedIllustration from './il-protected.svg'
import RedoIcon from './ic-redo.svg'
import ReorderIcon from './ic-reorder.svg'
import ReplaceAllIcon from './ic-replace-all.svg'
import ReplaceIcon from './ic-replace.svg'
import RestoreIcon from './ic-restore.svg'
import RichTextIcon from './ic-text-rich.svg'
import SafeIcon from './ic-safe.svg'
import SafeSquareFilledIcon from './ic-safe-square-filled.svg'
import SafeSquareIcon from './ic-safe-square.svg'
import SaveIcon from './ic-save.svg'
import SearchIcon from './ic-search.svg'
import SearchIosIcon from './ic-search-ios.svg'
import SecurityIcon from './ic-security.svg'
import SelectAllIcon from './ic-select-all.svg'
import SendIcon from './ic-send.svg'
import ServerIcon from './ic-server.svg'
import SettingsFilledIcon from './ic-settings-filled.svg'
import SettingsIcon from './ic-settings.svg'
import ShareIcon from './ic-share.svg'
import ShortcutButtonIcon from './ic-shortcut-button.svg'
import SignInIcon from './ic-signin.svg'
import SignOutIcon from './ic-signout.svg'
import SimplenoteIcon from './ic-simplenote.svg'
import SNLogoAltIcon from './ic-standard-notes-2.svg'
import SNLogoFull from './ic-sn-logo-full.svg'
import SNLogoIcon from './ic-standard-notes.svg'
import SortDescendingIcon from './ic-sort-descending.svg'
import SpreadsheetsIcon from './ic-spreadsheets.svg'
import StarCircleFilled from './ic-star-circle-filled.svg'
import StarFilledIcon from './ic-star-filled.svg'
import StarIcon from './ic-star.svg'
import StarVariantFilledIcon from './ic-star-variant-filled.svg'
import StrikethroughIcon from './ic-strikethrough.svg'
import SubscriptIcon from './ic-subscript.svg'
import SubtractIcon from './ic-subtract.svg'
import SuperscriptIcon from './ic-superscript.svg'
import SyncIcon from './ic-sync.svg'
import TasksIcon from './ic-tasks.svg'
import TextCircleIcon from './ic-text-circle.svg'
import TextIcon from './ic-text.svg'
import TextParagraphLongIcon from './ic-text-paragraph-long.svg'
import ThemesFilledIcon from './ic-themes-filled.svg'
import ThemesIcon from './ic-themes.svg'
import TimerIcon from './ic-timer.svg'
import TrashFilledIcon from './ic-trash-filled.svg'
import TrashIcon from './ic-trash.svg'
import TrashSweepFilledIcon from './ic-trash-sweep-filled.svg'
import TrashSweepIcon from './ic-trash-sweep.svg'
import TuneIcon from './ic-tune.svg'
import UnarchiveIcon from './ic-unarchive.svg'
import UnderlineIcon from './ic-underline.svg'
import UndoIcon from './ic-undo.svg'
import UnpinIcon from './ic-pin-off.svg'
import UploadIcon from './ic-upload.svg'
import UserAddIcon from './ic-user-add.svg'
import UserFilledIcon from './ic-user-filled.svg'
import UserIcon from './ic-user.svg'
import UserSwitch from './ic-user-switch.svg'
import ViewIcon from './ic-view.svg'
import WarningIcon from './ic-warning.svg'
import WindowIcon from './ic-window.svg'
import DetailsBlockIcon from './ic-details-block.svg'
import TableOfContentsIcon from './ic-toc.svg'

export {
  AccessibilityIcon,
  AccountCardDetailsOutlineIcon,
  AccountCircleIcon,
  AccountIllustration,
  AccountVariantIcon,
  AddBoldIcon,
  AddIcon,
  AddTextIcon,
  AegisIcon,
  ArchiveIcon,
  ArrowDownCheckmarkIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowsHorizontalIcon,
  ArrowsSortDownIcon,
  ArrowsSortUpIcon,
  ArrowsVerticalIcon,
  ArrowUpIcon,
  AsteriskIcon,
  AttachmentFileIcon,
  AuthenticatorIcon,
  AuthenticatorVariantIcon,
  BackIosIcon,
  BackspaceIcon,
  BlockIcon,
  BlueDotIcon,
  BoldIcon,
  BoxFilledIcon,
  BoxIcon,
  CameraIcon,
  CaretRightIcon,
  CheckAllIcon,
  CheckBoldIcon,
  CheckCircleFilledIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckListIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CircleIcon,
  ClearCircleFilledIcon,
  CloseCircleFilledIcon,
  ClockIcon,
  CloseIcon,
  CloudOffIcon,
  CodeIcon,
  CodeTagsIcon,
  ColorFillIcon,
  CopyIcon,
  CreateAccountIllustration,
  DashboardIcon,
  DetailsBlockIcon,
  DiamondFilledIcon,
  DiamondIcon,
  DownloadIcon,
  DragIcon,
  DrawIcon,
  EditorFilledIcon,
  EditorIcon,
  EmailFilledIcon,
  EmailIcon,
  EnterIcon,
  EvernoteIcon,
  EyeFilledIcon,
  EyeIcon,
  EyeOffFilledIcon,
  EyeOffIcon,
  FeedbackIcon,
  FileDocIcon,
  FileErrorIcon,
  FileFilledIcon,
  FileIcon,
  FileImageIcon,
  FileMovIcon,
  FileMusicIcon,
  FileOtherIcon,
  FilePdfIcon,
  FilePptIcon,
  FileSelectedIcon,
  FilesIllustration,
  FileXlsIcon,
  FileZipIcon,
  FolderFilledIcon,
  FolderIcon,
  FolderKeyFilledIcon,
  FormatAlignCenterIcon,
  FormatAlignJustifyIcon,
  FormatAlignLeftIcon,
  FormatAlignRightIcon,
  ForwardIosIcon,
  FullscreenExitIcon,
  FullscreenIcon,
  GiftOutlineIcon,
  GoogleKeepIcon,
  GroupIcon,
  HashtagFilledIcon,
  HashtagIcon,
  HashtagOffIcon,
  HeartFilledIcon,
  HelpFilledIcon,
  HelpIcon,
  HistoryIcon,
  HistoryLockedIllustration,
  IconsSpriteStylekit,
  IlNotesIcon,
  ImageIcon,
  IndentIcon,
  InfoIcon,
  ItalicIcon,
  KeyboardCloseIcon,
  KeyboardCommandIcon,
  KeyboardFilledIcon,
  KeyboardIcon,
  KeyboardOptionIcon,
  KeyboardShiftIcon,
  KeyboardShowIcon,
  LifebuoyIcon,
  LineWidthIcon,
  LinkIcon,
  LinkOffIcon,
  ListBulleted,
  ListedFilledIcon,
  ListedIcon,
  ListNumbered,
  LockFilledIcon,
  LockIcon,
  MarkdownIcon,
  MenuArrowDownAlt,
  MenuArrowDownIcon,
  MenuArrowRightIcon,
  MenuCloseIcon,
  MenuOpenIcon,
  MenuVariantIcon,
  MergeIcon,
  MoreIcon,
  MoreVertIcon,
  NoPreviewIllustration,
  NotesFilledIcon,
  NotesIcon,
  OpenInIcon,
  OutdentIcon,
  PasswordIcon,
  PencilFilledIcon,
  PencilIcon,
  PencilOffIcon,
  PinFilledIcon,
  PinIcon,
  PlainTextIcon,
  PlusCircleFilledIcon,
  PlusCircleIcon,
  PremiumFeatureIcon,
  PremiumIllustration,
  PrintIcon,
  ProtectedIllustration,
  RedoIcon,
  ReorderIcon,
  ReplaceAllIcon,
  ReplaceIcon,
  RestoreIcon,
  RichTextIcon,
  SafeIcon,
  SafeSquareFilledIcon,
  SafeSquareIcon,
  SaveIcon,
  SearchIcon,
  SearchIosIcon,
  SecurityIcon,
  SelectAllIcon,
  SendIcon,
  ServerIcon,
  SettingsFilledIcon,
  SettingsIcon,
  ShareIcon,
  ShortcutButtonIcon,
  SignInIcon,
  SignOutIcon,
  SimplenoteIcon,
  SNLogoAltIcon,
  SNLogoFull,
  SNLogoIcon,
  SortDescendingIcon,
  SpreadsheetsIcon,
  StarCircleFilled,
  StarFilledIcon,
  StarIcon,
  StarVariantFilledIcon,
  StrikethroughIcon,
  SubscriptIcon,
  SubtractIcon,
  SuperscriptIcon,
  SyncIcon,
  TableOfContentsIcon,
  TasksIcon,
  TextCircleIcon,
  TextIcon,
  TextParagraphLongIcon,
  ThemesFilledIcon,
  ThemesIcon,
  TimerIcon,
  TrashFilledIcon,
  TrashIcon,
  TrashSweepFilledIcon,
  TrashSweepIcon,
  TuneIcon,
  UnarchiveIcon,
  UnderlineIcon,
  UndoIcon,
  UnpinIcon,
  UploadIcon,
  UserAddIcon,
  UserFilledIcon,
  UserIcon,
  UserSwitch,
  ViewIcon,
  WarningIcon,
  WindowIcon,
}
